<template>
  <div class="users">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" />
    <div class="filters">
      <div class="search">
        <div class="option" ref="marketplaceRef">
          <span>Marketplace</span>
          <!-- <artmisads-input v-model:value="filters.marketplace" @press-enter="getPartData({})"
            placeholder="Enter Marketplace"></artmisads-input> -->
            <artmisads-select
            style="width: 232px"
            v-model:value="filters.marketplace"
            :getPopupContainer="() => marketplaceRef"
            :options="COUNTRY_BASE_OPTIONS"
            @change="onMarketplaceChange"
        />
        </div>
        <div class="option">
          <span>Seller</span>
          <a-auto-complete
            v-model:value="filters.sellerName"
            :options="options"
            style="width: 200px"
            size="large"
            @search="onSearch"
            @select="onSelect"
            allow-clear
            @clear="onResetComplete"
            placeholder="Select Username"
            :getPopupContainer="
                  triggerNode => {
                    return triggerNode.parentNode || document.body;
                  }
                "
          >
          </a-auto-complete>
          <!-- <artmisads-input v-model:value="filters.sellerId" @press-enter="getPartData({})"
            placeholder="Enter SellerId"></artmisads-input> -->
        </div>
        <div class="option">
          <span>BD</span>
          <artmisads-input v-model:value="filters.bd" @press-enter="getPartData({})"
            placeholder="Enter BD"></artmisads-input>
        </div>
      </div>
      <div class="button">
        <artmisads-button isSquare="true" type="primary" style="margin-right: 8px;" :loading="load"
          @click="getPartData({})">Search</artmisads-button>
        <artmisads-button isSquare="true" @click="onReset">Reset</artmisads-button>
      </div>
    </div>
    <div class="export">
      <artmisads-button isSquare="true" type="primary" @click="exportData">Export</artmisads-button>
    </div>
    <div class="table-data">
      <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="data" :change="onTableChange"
        :loading="load" :scroll="{ x: 1600, y: tableScrollHeight }">
        <template #bodyCell="{ column, text, index, record }">
          <div v-if="column.key !== 'action' && column.key !== 'user'">
            {{ text??'--' }}
          </div>
          <template v-if="column.key === 'user'">
            <div class="user">
              <div class="user-name">
                {{ record?.sellerName }}
              </div>
              <div class="user-email">{{ record?.sellerEmail }}</div>
            </div>
          </template>
          <template v-else-if="column.key === 'action'">
            <a target="_blank" :href="`/operator/finance/ar/seller-detail?sellerId=${record.sellerId}&marketplace=${filters.marketplace}&sellerName=${record.sellerName}`">Details</a>
          </template>
        </template>
      </artmisads-table>
    </div>
  </div>
</template>

<script setup>
import moment from "moment";
import { message } from "ant-design-vue";
import { ref, reactive, onMounted } from "vue";
import { financeApi } from "~/server/operator/finance";
import breadcrumbs from "../../breadcrumbs.vue";
import { COUNTRY_BASE } from "~/contants/common";
import { useTableScrollHeight } from "@/utils/useTableScrollHeight";
const marketplaceRef = ref(null);
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host;
  item.label = item.host;
  return item;
});
const breadcrumbsData = {
  title: "AR",
  des: "",
  links: [
  {
      name: "Home",
      path: "/operator/users",
    },
    {
      name: "Finance",
      path: "/operator/finance/payments",
    },
    {
      name: "AR",
      path: "/operator/finance/ar",
    },
  ],
};
const columns = [
  {
    title: "Seller",
    key: "user",
    dataIndex: "user",
    align:'center'
  },
  {
    title: "Marketplace",
    dataIndex: "marketplace",
    key: "marketplace",
    align:'center'
  },
  {
    title: "Accum.Accrued Income",
    dataIndex: "accumAccruedIncome",
    key: "accumAccruedIncome",
    align:'center'
  },
  {
    title: "Accum.Received",
    dataIndex: "accumReceived",
    key: "accumReceived",
    align:'center'
  },
  {
    title: "Accounts Receivable(Accrued)",
    dataIndex: "ar",
    key: "ar",
    align:'center',
    width:250
  },
  {
    title: "AR Aging Not Due",
    dataIndex: "arNotDue",
    key: "arNotDue",
    align:'center'
  },
  {
    title: "AR Aging 1-30 Days",
    dataIndex: "ar1To30Days",
    key: "ar1To30Days",
    align:'center'
  },
  {
    title: "AR Aging 31-60 Days",
    dataIndex: "ar31To60Days",
    key: "ar31To60Days",
    align:'center'
  },
  {
    title: "AR Aging 60 Days+",
    dataIndex: "arOver60Days",
    key: "arOver60Days",
    align:'center'
  },
  {
    title: "BD",
    dataIndex: "bd",
    key: "bd",
    align:'center',

  },
  {
    key: "action",
    fixed: 'right',
    title: "action",
    align:'center'
  },
];
let filters = reactive({
  marketplace: 'amazon.com',
  sellerId: '',
  sellerName: '',
  bd: ''
});
let data = ref([]);
let _data = [];
let load = ref(true);
const pagination = reactive({
  current: 1,
  defaultPageSize: 10,
  size: 10,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
});
let options=ref([])
let _options=[];
const onTableChange = ({ current, pageSize }) => {
  pagination.current = current;
  pagination.size = pageSize;
  pagination.pageSize = pageSize;
  getPartData({ page: current, size: pageSize });
};

const init = () => {
  financeApi.getFinanceARagingReport({ size:  pagination.pageSize,marketplace:filters.marketplace }).then((res) => {
    data.value = res.data;
    _data = res.data;
    pagination.total = res.total;
    financeApi.getFinanceARagingReport({ size:res.total }).then((resAll) => {
      resAll.data.forEach(v=>{
      let isId=_options.find(item=>item.sellerId == v.sellerId);
      if(!isId){
        _options.push({
        value:v.sellerName,
        sellerId:v.sellerId
        });
      }
     })
    load.value = false;
    })
  });
};
const getPartData = (params) => {
  load.value = true;
  if(Object.keys(params).length === 0){
    pagination.current=1
  }
  let _params = {
    page: 1,
    size: pagination.size,
    marketplace: filters.marketplace,
    sellerId: filters.sellerId,
    bd: filters.bd
  };
  let newparams = { ..._params, ...params };
  newparams = Object.keys(newparams).reduce((acc, key) => {
    if (
      newparams[key] !== null &&
      newparams[key] !== undefined &&
      newparams[key] !== ""
    ) {
      acc[key] = newparams[key];
    }
    return acc;
  }, {});
  financeApi.getFinanceARagingReport(newparams).then((res) => {
    if (res?.data) {
      if (params.size || params.page) {
        document.querySelector(".filters").scrollIntoView({
          behavior: "smooth",
        });
      }

      data.value = res.data;
      pagination.total = res.total;
      
    }
   else{
    message.error('Failure');
   }
   load.value = false;
  });
};
const onReset = () => {
  filters.marketplace = 'amazon.com';
  filters.sellerId = '';
  filters.sellerName='';
  filters.bd = '';
  pagination.current = 1;
  init();
}
const onResetComplete=()=>{
  filters.sellerId = '';
  filters.sellerName='';
}
const onSearch=e=>{
  options.value=[];
  if(e){
    let res=_options.filter(v=>v.value.toLowerCase().startsWith(e.toLowerCase()))
    if(res?.length>0){
      options.value=res;
    }
  }
}
const onSelect=e=>{
  let res=_options.find(v=>v.value == e);
  filters.sellerId=res.sellerId;  
}
const onMarketplaceChange=e=>{
  filters.sellerId = '';
  filters.sellerName='';
  _options=[]
  options.value=[];

  financeApi.getFinanceARagingReport({ size:9999,marketplace:e }).then((resAll) => {
      resAll.data.forEach(v=>{
      let isId=_options.find(item=>item.sellerId == v.sellerId);
      if(!isId){
        _options.push({
        value:v.sellerName,
        sellerId:v.sellerId
        });
      }
     })
    })
}

const exportData = () => {
  let params = {
    page: pagination.current,
    size: pagination.size,
    marketplace: filters.marketplace,
    sellerId: filters.sellerId,
    bd: filters.bd,
  };
  let time = moment().format("YYYY-MM-DD");
  const finalParams = {
    qs: params,
    fileName: `All Sellers_${time}.csv`,
    platform: 'operator',
  };
  financeApi.sellerExportARagingReport(finalParams)
};
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-data',
  bottomSpace: 280,
  minHeight: 200,
  maxHeight:1000,
  defaultHeight: 350
});
onMounted(() => {
  init();
});
</script>

<style lang="less" scoped>
.users {
  padding: 16px;
  padding-top: unset;
  width: 100%;
}

.filters {
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;

    .option {
      >span {
        margin-right: 8px;
      }

      display: flex;
      align-items: center;
      margin-right: 24px;
    }
  }
}

.export {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
}

.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;
  :deep(.ant-table) {
    border-radius: 8px 8px 0 0;
  }

  :deep(.ant-table-cell) {
    padding-left: 8px;
    padding-right: 8px;

    >a {
      color: var(--primary);

      &:hover {
        color: var(--primary-hover);
      }
    }
  }

  :deep(.ant-table-thead) {
    border-radius: 8px 8px 0 0;
  }

  .user {
    flex: 1;

    .user-name {
      color: var(--dark-1);
      font-weight: 500;
      font-size: 16px;
      letter-spacing: 0.4px;
      line-height: 20px;

      >span {
        font-weight: 400;
        margin-left: 4px;
      }
    }

    .user-email {
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 16px;
      padding: 10px 0;
    }

    .user-id {
      height: 16px;
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      line-height: 16px;
    }
  }

}

.show-url {
  word-break: break-all;
}

.pending-amount {
  color: var(--red-1);
}

.actions {
  gap: 8px;
  display: flex;
}
</style>
